// extracted by mini-css-extract-plugin
module.exports = {"container":"ForSurrogate_container__2q4F7","buttonWrapper":"ForSurrogate_buttonWrapper__2bacW","button":"ForSurrogate_button__2RtI_"};